module.exports = __webpack_public_path__ + "img/nana-kwame-adjei-brenyah.9acdac53.png";